module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-12.53098b29.png";